import React, { useState } from 'react';
import { IpaType } from '../../phonemes/ipa';
import { speakSegment } from '../speakSegment';
import { FormantsChart } from './FormantsChart';

/** show diphthongs on a formants chart w/ their synth approximations that you can hear */
export function SynthDiphthongFormants(props: {
  formants: Record<IpaType, number[]>,
  hideSymbols?: string[]
}) {
  const [diphthongs] = useState(Object.getOwnPropertyNames(props.formants));

  function whatColor(ipa: IpaType): string {
    if (props.hideSymbols && props.hideSymbols.includes(ipa)) {
      return 'white';
    }
    return props.formants[ipa] ? 'rgb(0, 160, 0)' : 'grey';
  }

  return <FormantsChart diphthongs={diphthongs}
    clicked={speakSegment} clickedDiphthong={speakSegment}
    width={600} height={300} whatColor={whatColor} />;
}
